import React from "react";
import c from "classnames";

import css from "./block.module.scss";

const ImageBlock = ({ src, style, children, className, innerClassName, width, height, imgProps }) => {
  return (
    <div style={{ ...style }} className={c(css["ib-wrapper"], className)}>
      <img src={src} className={c(css["image"])} width={width} height={height} {...imgProps}/>
      <div className={innerClassName}>{children}</div>
    </div>
  );
};

export default ImageBlock;
